<template>
  <section class="container content-padding">

    <div class="row">
      <div class="col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 p-0">
        <div class="text-right pb-2">
          <span v-if="!displayForm">
            <button class="btn btn-info" @click="displayForm = true">แสดงฟอร์มค้นหา</button>
          </span>
          <span v-else>
            <button class="btn btn-danger" @click="displayForm = false">ปิดฟอร์มค้นหา</button>
          </span>
        </div>
        <div class="card" v-if="displayForm">
          <div class="card-body">
            <div><h3>ค้นหารายได้ของคุณ</h3></div>
            <section>
              <div class="pl-2"><label>{{ lastYear }}</label></div>
              <div class="row">
                <div class="col-4 col-lg-3" v-for="(month, index) in lastYearMonths">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" :value="`${index+1}-${lastYear}`" v-model="selectedMonthsYears"> {{ month
                      }}
                    </label>
                  </div>
                </div>
              </div>
            </section>

            <section class="pt-3">
              <div class="pl-2"><label>{{ currentYear }}</label></div>
              <div class="row">
                <div class="col-4 col-lg-3" v-for="(month, index) in currentMonths">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" :value="`${index+1}-${currentYear}`" v-model="selectedMonthsYears"> {{
                      month }}
                    </label>
                  </div>
                </div>
              </div>
            </section>
            <hr>
            <div class="checkbox">
              <label>
                <input type="checkbox"
                       v-model="viewAllIncome"
                       :true-value="true"
                       :false-value="false"> ดูข้อมูลรายได้ทั้งหมด
              </label>
            </div>

            <div class="pt-3">
              <button class="btn btn-info btn-block" @click="fetchProfessionalEarnings()">แสดงข้อมูลรายได้</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section v-if="professionalEarningsData">
      <div class="row pb-4">
        <div class="col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 p-0">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link pointer-item"
                 :class="{'active': selectedMenu === 'professional_income'}"
                 @click.prevent="selectedMenu = 'professional_income'">รายได้</a>
            </li>
            <li class="nav-item">
              <a class="nav-link pointer-item"
                 :class="{'active': selectedMenu === 'professional_tip'}"
                 @click.prevent="selectedMenu = 'professional_tip'">ค่าทิป</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row" v-if="selectedMenu === 'professional_income'">
        <div class="col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 p-0">

          <div class="text-center" v-if="professionalEarningsData && professionalEarningsData.earnings.length === 0">
            <h4>ไม่มีข้อมูล</h4>
          </div>

          <div class="row">
            <div class="col-12 text-center pb-4">
              <div class="income-title">{{ professionalEarningsData.total_earnings | currency }}</div>
              <h4>รายได้ของคุณ</h4>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
              <tr>
                <th class="text-center">No.</th>
                <th class="text-center">รหัสงาน</th>
                <th class="text-center">วันที่และเวลา</th>
                <th class="text-center">ประเภท</th>
                <!--              <th class="text-center">สถานะ</th>-->
                <th class="text-center">รายได้</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(earnings, index) in sortedEarnings">
                <td class="text-center">{{ index+=1 }}.</td>
                <td class="text-center">#{{ earnings.order_code }}</td>
                <td class="text-center">{{ earningsDate(earnings) | prettyDate }}</td>
                <td class="text-center">
                  <span v-html="customerType(earnings.is_business)"></span>
                </td>
                <!--              <td class="text-center">-->
                <!--                <span v-html="orderStatus(earnings.status, earnings.cancel)"></span>-->
                <!--              </td>-->
                <td class="text-center"><label class="mb-0">{{ earnings.professional_income | numberWithCommas }}</label></td>
              </tr>
              <tr>
                <td colspan="4" class="text-right">
                  <h4 class="mb-0">รวมทั้งสิ้น</h4>
                </td>
                <td>
                  <h4 class="mb-0 text-center">{{ professionalEarningsData.total_earnings | numberWithCommas }}</h4>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 p-0">

          <div class="text-center" v-if="professionalEarningsData && professionalEarningsData.total_professional_tips.length === 0">
            <h4>ไม่มีข้อมูล</h4>
          </div>

          <div class="row">
            <div class="col-12 text-center pb-4">
              <div class="income-title">{{ professionalEarningsData.total_professional_tips | currency }}</div>
              <h4>ทิปที่คุณได้รับ</h4>
            </div>
          </div>
          <table class="table table-striped" v-if="professionalEarningsData.professional_tips.length > 0">
            <thead>
            <tr>
              <th class="text-center">No.</th>
              <th class="text-center">รหัสงาน</th>
              <th class="text-center">วันที่และเวลาที่ลูกค้าให้ทิป</th>
              <th class="text-center">รายได้</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(professionalTip, index) in sortedTips">
              <td class="text-center">{{ index+=1 }}.</td>
              <td class="text-center">#{{ professionalTip.order.code }}</td>
              <td class="text-center">{{ professionalTip.paid_at | prettyDate }}</td>
              <td class="text-center">
                <label class="mb-0">{{ Number(professionalTip.professional_income) | numberWithCommas }}</label>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="text-right">
                <h4 class="mb-0">รวมทั้งสิ้น</h4>
              </td>
              <td>
                <h4 class="mb-0 text-center">{{ professionalEarningsData.total_professional_tips | numberWithCommas }}</h4>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="text-center" v-if="isLoading">
        <loader></loader>
        <div>กำลังโหลดข้อมูล...</div>
      </div>

    </section>
  </section>
</template>

<script>
  import axios from 'axios'
  import Loader from '../loader/Loader'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        selectedMenu: 'professional_income',
        displayForm: true,
        viewAllIncome: false,
        selectedMonthsYears: [],
        lastYear: new Date().getFullYear() - 1,
        currentYear: new Date().getFullYear(),
        currentMonths: [],
        lastYearMonths: [],
        professionalEarningsData: null,
        fromAdmin: 0,
        isLoading: false
      }
    },
    computed: {
      sortedEarnings () {
        return this._.orderBy(this.professionalEarningsData.earnings, ['cleaning_date'], ['desc'])
      },
      sortedTips () {
        if (this.professionalEarningsData.professional_tips) {
          return this._.orderBy(this.professionalEarningsData.professional_tips, ['created_at'], ['desc'])
        } else {
          return null
        }
      }
    },
    watch: {
      viewAllIncome () {
        if (this.viewAllIncome) {
          this.selectedMonthsYears = []
        }
      },
      selectedMonthsYears () {
        if (this.selectedMonthsYears.length > 0) {
          this.viewAllIncome = false
        }
      }
    },
    methods: {
      async fetchProfessionalEarnings () {
        if (this.selectedMonthsYears.length === 0 && !this.viewAllIncome) {
          this.$swal({text: 'กรุณาเลือกข้อมูลที่คุณต้องการ', type: 'error'})
        } else {
          this.isLoading = true
          this.professionalEarningsData = null
          const params = {
            professional_id: this.$route.params.id,
            paid_status: 1,
            fetch_all: this.viewAllIncome,
            from_admin: this.fromAdmin
          }
          if (this.selectedMonthsYears.length > 0) {
            params.selected_months_years = this.selectedMonthsYears.toString()
          }
          const url = `professionals/${params.professional_id}/earnings`
          const {data} = await axios.get(url, {params})
          this.isLoading = false
          if (data) {
            this.professionalEarningsData = data
          }
        }
      },
      earningsDate (earnings) {
        const status = Number(earnings.status)
        const cancel = Number(earnings.cancel)
        return (cancel > 0 || status === 1) ? earnings.cleaning_date : earnings.complete_cleaning_date
      },
      customerType (isBusiness) {
        isBusiness = Number(isBusiness)
        return (isBusiness === 1) ? '<i class="fas fa-briefcase"></i> ธุรกิจ' : '<i class="fas fa-user"></i> ลูกค้าทั่วไป'
      },
      orderStatus (status, cancel) {
        status = Number(status)
        cancel = Number(cancel)
        let result = ''
        if (cancel > 0) {
          result = '<span class="badge -status -canceled">' + this.$i18n.t('message.order_status.canceled') + '</span>'
        } else {
          switch (status) {
            case 0:
              result = '<span class="badge -status -new">' + this.$i18n.t('message.order_status.new') + '</span>'
              break
            case 1:
              result = '<span class="badge -status -new">' + this.$i18n.t('message.order_status.new') + '</span>'
              break
            case 2:
              result = '<span class="badge -status -completed">' + this.$i18n.t('message.order_status.completed') + '</span>'
              break
          }
        }
        return result
      }
    },
    mounted () {
      this.$store.commit('professional/SET_PROFESSIONAL_EARNINGS_DATA', null)
      // this.fetchProfessionalEarnings()
    },
    created () {
      const currentMonth = new Date().getMonth()
      const monthNames = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
      for (let i = 0; i <= currentMonth; i++) {
        this.currentMonths.push(monthNames[i])
      }
      for (let i = 0; i < monthNames.length; i++) {
        this.lastYearMonths.push(monthNames[i])
      }
      this.fromAdmin = (this.$route.query && this.$route.query.from_admin) ? this.$route.query.from_admin : 0
    }
  }
</script>

<style>
  .income-title {
    font-size: 220%;
  }
</style>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalIncome.vue